__webpack_require__.p = "/trading-bot/client/";